export default "__VITE_ASSET__0dLLxCsw__"